import { FC, Fragment, memo } from "react";
import { FormikHandlers } from "formik";
import { useDidMount } from "rooks";
import {
  AutocompleteFilterBody,
  AutocompleteFilterBodyProps,
} from "../AutocompleteFilterBody";
import {
  FilterItem,
  Operator,
  usePostUsersMeEbsSnapshotVolumeIdsMutation,
} from "../../../../../../../../services/cloudchipr.api";
import { FilterItemOperatorType } from "../../../FilterItemOperatorType";

interface VolumeIdFilterProps extends AutocompleteFilterBodyProps {
  accountIds?: string[];
  filter: FilterItem;
  operators?: Operator[];
  onChange: FormikHandlers["handleChange"];
}

export const VolumeIdFilter: FC<VolumeIdFilterProps> = memo(
  ({ accountIds, operators, filter, onChange, ...props }) => {
    const [trigger, { data, isLoading }] =
      usePostUsersMeEbsSnapshotVolumeIdsMutation();

    useDidMount(() => {
      if (!accountIds) {
        return;
      }
      trigger({
        body: { account_ids: accountIds },
      });
    });

    return (
      <Fragment>
        <FilterItemOperatorType
          onChange={onChange}
          options={operators}
          value={filter.operator || "in"}
        />

        <AutocompleteFilterBody
          {...props}
          options={data ?? []}
          isLoading={isLoading}
          label="Volume Id"
          selectedValue={Array.isArray(filter?.value) ? filter.value : []}
        />
      </Fragment>
    );
  },
);
